import { useState } from 'react';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CampaignStudioTile({
  portalId,
  valueToDisplay
}) {
  const [isOpen, setIsOpen] = useState(true);
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Tile, {
    compact: true,
    closeable: true,
    padding: "500",
    onClose: () => setIsOpen(false),
    children: [/*#__PURE__*/_jsxs(TileSection, {
      padding: "0",
      paddingBlockEnd: "500",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-100",
        color: "text-core-default",
        paddingBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.campaignStudioTile.title"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.campaignStudioTile.description"
        })
      })]
    }), /*#__PURE__*/_jsx(TileSection, {
      padding: "0",
      children: /*#__PURE__*/_jsx(Button, {
        href: `/marketing/${portalId}/studio/${valueToDisplay}`,
        target: "_blank",
        rel: "noopener noreferrer",
        external: true,
        use: "tertiary",
        size: "md",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.campaignStudioTile.buttonText"
        })
      })
    })]
  });
}